module.exports = __webpack_public_path__ + "static/littleWomen1-96c8ba51ae4ea7735055db522d3415b7.jpg";